webpackJsonp([70144966829960],{

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SectionLandingPageQuery = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _contentFilter = __webpack_require__(109);
	
	var _contentFilter2 = _interopRequireDefault(_contentFilter);
	
	var _seo = __webpack_require__(53);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	    _inherits(ContactPage, _React$Component);
	
	    function ContactPage(props) {
	        _classCallCheck(this, ContactPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.filterCallback = function (name, event) {
	            var selected = event.target.value;
	            var filteredTraders = (0, _getContents.stripNode)(_this.props.data.traders.edges);
	            var filteredLocations = (0, _getContents.stripNode)(_this.props.data.locations.edges);
	            var selectedTag = '';
	            var selectedLocation = '';
	            if (selected != '') {
	                if (name == 'location') {
	                    selectedLocation = selected;
	                    filteredTraders = _this.props.data.traders.edges.filter(function (insight) {
	                        return insight.location.location == selected;
	                    });
	                }
	            } else {
	                filteredTraders = [];
	            }
	            _this.setState({
	                traders: filteredTraders,
	                locations: filteredLocations,
	                selectedTag: selectedTag,
	                selectedLocation: selectedLocation
	            });
	        };
	
	        _this.state = {
	            location: '',
	            tags: [],
	            selectedTag: '',
	            locations: (0, _getContents.stripNode)(props.data.locations.edges),
	            selectedLocation: '',
	            allLocations: props.data.locations.edges.map(function (location) {
	                return location.location;
	            }),
	            traders: []
	        };
	        return _this;
	    }
	
	    ContactPage.prototype.render = function render() {
	        var subpageLayout = false;
	
	        var seo = {
	            title: 'Contact us'
	        };
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_seo2.default, seo),
	            _react2.default.createElement(
	                'div',
	                {
	                    className: 'contactpage section ' + (subpageLayout == true ? 'indented-contents pt-60' : '') },
	                _react2.default.createElement(_components2.default, {
	                    content: {
	                        __typename: 'sidebysidetext',
	                        title: 'Contact us',
	                        body: ''
	                    }
	                }),
	                _react2.default.createElement(_components2.default, {
	                    content: {
	                        __typename: 'DatoCmsContactOnLandingpage',
	                        title: '',
	                        people: [this.props.data.peter, this.props.data.kent, this.props.data.steffen]
	                    },
	                    ignoreIndent: true
	                }),
	                _react2.default.createElement(_contentFilter2.default, {
	                    defaultLocationText: 'Choose supply location',
	                    callback: this.filterCallback,
	                    tags: this.state.tags,
	                    selectedTag: this.state.selectedTag,
	                    locations: this.state.allLocations,
	                    selectedLocation: this.state.selectedLocation,
	                    showTag: false
	                }),
	                _react2.default.createElement(_components2.default, {
	                    content: {
	                        __typename: 'DatoCmsTradersLocationCollection',
	                        traders: this.state.traders,
	                        locations: this.state.locations,
	                        selectedLocation: this.state.selectedLocation
	                    },
	                    ignoreIndent: true
	                })
	            )
	        );
	    };
	
	    return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	var SectionLandingPageQuery = exports.SectionLandingPageQuery = '** extracted graphql fragment **';
	
	// date(formatString: "MMMM DD, YYYY")

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-a395ce39fe7535663df6.js